/**
 * @Author: maple
 * @Date: 2019-11-01 16:54:12
 * @LastEditors: maple
 * @LastEditTime: 2019-11-01 16:58:24
 */
import createAPI from './hotel-api';

const credentialsConf = {
  withCredentials: true,
  validateStatus: () => true,
};

const api = createAPI(process.env.MUJI_APP_HOST, {
  showNotification: true,
});

export function fetchDocsBar() {
  return api.getJson('/portal/api/v2/darts-docs-stable/side-bar', {}, credentialsConf);
}

export function fetchApi({ apiId }) {
  return api.getJson(`/portal/api/darts-docs-stable/api/${apiId}`, {}, credentialsConf);
}

export function fetchGroupApis({ groupId }) {
  return api.getJson(`/portal/api/v2/darts-docs-stable/side-bar/group/${groupId}`);
}
